import React from "react";

import { createSvgIconComponent } from "../utils";

export const IconCatch = createSvgIconComponent({
  viewBox: "0 0 300 132",
  children: (
    <image xlinkHref="https://s.catch.com.au/static/catch/images/logo-83d9b21199.svg" />
  ),
});
